import { useSelector, shallowEqual } from "react-redux";
import { allMenuItems } from "../../Layouts/MenuItems";

const useNavMenu = () => {
  const { userProfile } = useSelector(
    (state) => ({
      userProfile: state.auth.isUserData,
    }),
    shallowEqual
  );

  const accessibleRoutes = userProfile?.accessibleRoutes || [];
  const isSuperAdmin = userProfile?.role === "Admin";

  const filterAndKeepStructure = (items) => {
    if (!items) return [];

    return items.filter((item) => {
      if (item.isHeader) return true;
      let hasAccess = false;

      if (item.link && item.link !== "/#") {
        hasAccess = isSuperAdmin || accessibleRoutes.includes(item.link);
      }

      if (item.subItems) {
        const filteredSubItems = filterAndKeepStructure(item.subItems);

        if (filteredSubItems.length > 0) {
          item.subItems = filteredSubItems;
          return true;
        }
      }

      return hasAccess;
    });
  };

  const authorizedMenu = isSuperAdmin
    ? allMenuItems
    : filterAndKeepStructure(JSON.parse(JSON.stringify(allMenuItems)));

  return authorizedMenu;
};

export default useNavMenu;
